import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { Blade, Button } from "rhombus-react";
import { groupErrorsByCode, groupMessagesByPosition, DOCUMENTATION_URL } from "utils/UpdatesHistory";

import "./ErrorDetailsModal.css";

export default function ErrorDetailsModal({ errors, onClose }) {
	const groupedErrors = groupErrorsByCode(errors);
	const errorCodeCount = Object.keys(groupedErrors).length;
	const issueText = errorCodeCount > 1 ? "these issues" : "this issue";

	function renderContent() {
		return (
			<div className="error-details-modal-body">
				<div className="error-details-scrollable">
					{Object.entries(groupedErrors).map(([code, messages]) => {
						const groupedMessages = groupMessagesByPosition(messages);
						return (
							<div key={code} className="error-code-group">
								<div className="error-code-header">{code}</div>
								<ul className="error-message-list">
									{groupedMessages.map(msg => <li key={msg}>{msg}</li>)}
								</ul>
							</div>
						);
					})}
				</div>
				<div className="error-details-help">
					<strong>
						<a
							href={DOCUMENTATION_URL}
							target="_blank"
							rel="noopener noreferrer"
						>
							{`Learn more about ${issueText}`}
						</a>
					</strong>
				</div>
			</div>
		);
	}

	function renderFooter() {
		return (
			<Button theme="blue" onClick={onClose}>Close</Button>
		);
	}

	return ReactDOM.createPortal(
		<Blade
			type="modal"
			title="Error Details"
			className="error-details-modal"
			allowFullScreen={false}
			bladeProps={{ verticallyCenter: true }}
			xClose
			onClose={onClose}
			renderContent={renderContent}
			renderFooter={renderFooter}
			setAppTitle={false}
		/>,
		document.body
	);
}

ErrorDetailsModal.displayName = "ErrorDetailsModal";

ErrorDetailsModal.propTypes = {
	errors: PropTypes.arrayOf(PropTypes.shape({
		code: PropTypes.string.isRequired,
		message: PropTypes.string.isRequired,
	})).isRequired,
	onClose: PropTypes.func.isRequired,
};
